<div class="po-details">
    <!-- <div class="modal-header">
        <div class="row w-100">
            <div class="col-md-11">
                <h4 class="modal-title">Details</h4>
            </div>
            <div class="col-md-1">
                <app-print-common [rowData]="rowData" [columns]="columns"></app-print-common>
            </div>
        </div>
    </div> -->
    <div class="modal-body">

        <div class="card p-3 mb-2">
            <div class="row py-1">
                <div class="col-sm-5 border-right">
                    <h2>General Information</h2>
                    <p class="mb-2">
                        <label class="form-label-order">Warehouse Location:&nbsp;</label>
                        <span>{{rowData?.districtName | lowercase}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Type of Manpower Required:&nbsp;</label>
                        <span>{{ getUniqueSkills() }}</span>
                    </p>
                    <!-- <p class="mb-2">
                        <label class="form-label-order">Number of Labourers: </label>
                        <span></span>
                    </p> -->
                    <!-- <p class="mb-2">
                        <label class="form-label-order">Shift Date & Time: </label>
                        <span></span>
                    </p> -->
                    <p class="mb-2">
                        <label class="form-label-order">Status:&nbsp;</label>
                        <span
                        [ngClass]="
                        {
                            'draft': rowData?.status == 'Draft',
                            'primaryPill': rowData?.status == 'Created' ||  rowData?.status == 'Closed',
                            'commentedPill': rowData?.status == 'PendingOnVendor' || rowData?.status == 'PendingOnCustomer',
                            'successPill': rowData?.status == 'AcceptedByVendor' || rowData?.status == 'AcceptedByCustomer',
                            'errorPill': rowData?.status == 'Cancel'|| rowData?.status == 'RejectedByVendor' || rowData?.status == 'RejectedByCustomer',
                        }">{{getStatusText(rowData?.status, userType)}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Duration:&nbsp;</label>
                        <span>{{rowData?.fromDate | CustomDatePipe: 'D-M-YYYY'}} to {{rowData?.toDate | CustomDatePipe:
                            'D-M-YYYY' }}</span>
                    </p>
                </div>
                <div class="col-sm-1"></div>
                <div class="col-sm-5">
                    <h2>Contact Person Information</h2>
                    <p class="mb-2">
                        <label class="form-label-order">Name:&nbsp; </label>
                        <span>{{rowData?.contactName}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Mobile Number:&nbsp;</label>
                        <span>{{rowData?.contactMobile}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Alternate Number:&nbsp;</label>
                        <span>{{rowData?.contactAlternateMobile}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Email:&nbsp;</label>
                        <span>{{rowData?.contactEmail}}</span>
                    </p>
                    <!-- <p class="mb-2">
                        <label class="form-label-order">Status:&nbsp;</label>
                        <span>{{rowData?.status}}</span>
                    </p> -->
                </div>
            </div>
        </div>


        <div class="card p-3 mb-2">
            <div class="table-responsive-scroll">
                <div class="mt-0 mb-2">
                    <h2>
                        <span>Manpower Details</span>
                    </h2>
                </div>

                <table class="table mt-2 counter-table">
                    <thead>
                        <tr>
                            <th class="sticky-col" rowspan="">Role</th>
                            <th class="sticky-col" rowspan="">Head Count</th>
                            <th style="width: 150px;">Basic Wage</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let group of parentOrder?.jobLineItems; let i = index">
                            <td class="sticky-col">
                                 <a class="linklick" (click)="viewPickUpDropLocation(group)">
                                <ng-container *ngIf="group?.routeCode; else noRoute">
                                    {{ group?.routeCode }}: {{ group?.routeSource }} - {{ group?.routeDestination }}
                                </ng-container>
                                <ng-template #noRoute>
                                    {{ group?.skill }}
                                </ng-template>
                                </a>
                            </td>
                            <td class="customer-column">{{ group?.headCount }}</td>
                            <td class="customer-column">{{ group?.maxSalary }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>


        
        <ng-container *ngIf="rowData?.status != 'Created'">
            <div class="table-responsive-scroll" *ngIf="userType==='CUSTOMER'">
                <table class="table mt-2 counter-table">
                    <thead>
                        <tr>
                            <th rowspan="2">Action</th>
                            <th rowspan="2">Vendor Name</th>
                            <th rowspan="2"> Status</th>
                            <th rowspan="2" class="w-110"> Role &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <!-- <th class="sticky-col" rowspan="2" style="width: 100px;">Route</th> -->
                            <th colspan="2" class="text-center">Vendor Proposal</th>
                            <th colspan="2" class="text-center">Customer Price</th>
                            <!-- <th colspan="2" class="text-center">Proposal</th> -->
                        </tr>

                        <tr>
                            <th (click)="sortData('jobLineItems.vendorCount')">Head Count <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                            <th (click)="sortData('jobLineItems.vendorPrice')">Basic Wage <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                            
                            <th (click)="sortData('jobLineItems.headCount')">Head Count  <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                            <th (click)="sortData('jobLineItems.maxSalary')">Basic Wage  <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let group of groupedLineItems; let i = index">
                            <td align="center">
                                <div class="btn-block mt-3" *ngIf="group?.status !== 'Cancel' && group?.status !== 'Closed'">
                                    <ng-container *ngIf="customerAccRejectBtn(group)">
                                        <button class="btn btn-primary mr-2"
                                            (click)="orderUpdate(group, 'ACCEPT')">Accept</button> <br />
                                        <button class="btn btn-primary reject mr-2"
                                            (click)="orderUpdate(group, 'REJECT')">Reject</button>
                                    </ng-container>
                                    <div
                                        *ngIf="group?.counterNumber !== null && group?.counterNumber < 3">
                                        <div *ngIf="hasCustomerStatus(group)">
                                            <button class="btn btn-primary" style="height: 30px;"
                                                (click)="showCounterpopUp(group)">
                                                {{ group.showCounter ? 'Cancel' : 'Create Counter' }}
                                            </button>
                                        </div>
                                    </div>
                                    <!-- <span *ngIf="group.showCounter" class="text-right">
                                        <button class="btn btn-success" (click)="submitCounter(group)">
                                            Submit Counter
                                        </button>
                                    </span> -->
                                </div>
                            </td>
                            <td style="width:120px" [attr.rowspan]="group.length">
                                <a class="linklick" (click)="transactionPraposal(group)">{{group.vendorName}} </a>
                            </td>
                            <td>
                                <p class="mb-0">
                                    <span [ngClass]="
                                        {
                                            'draft': group?.status == 'Draft',
                                            'primaryPill': group?.status == 'Created' ||  group?.status == 'Closed',
                                            'commentedPill': group?.status == 'PendingOnVendor' || group?.status == 'PendingOnCustomer',
                                            'successPill': group?.status == 'AcceptedByVendor' || group?.status == 'AcceptedByCustomer',
                                            'errorPill': group?.status == 'Cancel'|| group?.status == 'RejectedByVendor' || group?.status == 'RejectedByCustomer',
                                        }">{{getStatusText(group?.status , userType)}}</span>
                                </p>
                            </td>
                            <!-- <td class="sticky-col" style="width:100px">
                                {{group?.items[0]?.routeCode}}: {{ group?.items[0]?.routeSource }} -
                                {{group?.items[0]?.routeDestination}}
                            </td> -->
                            <td colspan="5" style="padding: 0;">
                                <table style="width: 100%;" class="inner-table">
                                    <tr *ngFor="let item of group.items">
                                        <!-- <td>{{item?.skill}}</td> -->
                                        <td class="customer-column w-110" >{{ item?.skill || '' }} </td>
                                        <td class="customer-column w-110" [ngClass]="group?.finalAcceptance == 'VENDOR' && group?.status == 'AcceptedByCustomer' ? 'accepted-price':''">{{ item?.vendorCount || '' }} </td>
                                        <td class="customer-column w-110" [ngClass]="group?.finalAcceptance == 'VENDOR' && group?.status == 'AcceptedByCustomer' ? 'accepted-price':''">{{ item?.vendorPrice || '' }}</td>
                                        <td class="customer-column w-110" [ngClass]="group?.finalAcceptance == 'CUSTOMER' && group?.status == 'AcceptedByCustomer' ? 'accepted-price':''">
                                            {{ 
                                            (group?.counterNumber == 0 && group?.status == 'AcceptedByCustomer') 
                                                ? item.headCount 
                                                : (group?.counterNumber == 0 || group?.status == 'PendingOnCustomer') 
                                                ? '' 
                                                : item.headCount 
                                            }}
            
                                            <!-- {{ group?.counterNumber == 0 || ( group?.status == 'PendingOnCustomer')? '' : item.numberOfVehicle}} -->
                                        </td>
                                        <td class="customer-column w-110" [ngClass]="group?.finalAcceptance == 'CUSTOMER' && group?.status == 'AcceptedByCustomer' ? 'accepted-price':''">
                                           {{ 
                                            (group?.counterNumber == 0 && group?.status == 'AcceptedByCustomer') 
                                                ? item.maxSalary 
                                                : (group?.counterNumber == 0 || group?.status == 'PendingOnCustomer') 
                                                ? '' 
                                                : item.maxSalary 
                                            }}
                                            <!-- {{ group?.counterNumber == 0 || (group?.status =='PendingOnCustomer' )? '' : item.maxSalary}} -->
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <!-- <td class="customer-column">{{ group.items[0]?.numberOfVehicle }}</td> -->
                            <!-- <td class="customer-column">{{ group.items[0]?.maxSalary }}</td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>



        <!-- TABS -->
        <div class="relative-card" *ngIf="jobDetails?.length" style="display:none">
            <ul class="tabs">
                <li *ngFor="let vendor of jobDetails; let i = index" [class.active-tab]="i === activeTabIndex"
                    (click)="onVendorTabClick(i)">
                    {{ vendor?.vendorName }}
                </li>
            </ul>
        </div>

        <!-- PENDING/APPROVE/REJECT order Proposal -->
        <ng-container *ngIf="userType==='CUSTOMER'">
            <ng-container *ngFor="let group of groupedLineItems; let gIndex = index">
                <div class="card p-3 mb-2" style="display:none">
                    <div class="row">
                        <div class="col">
                            <h2>
                                <span
                                    *ngIf="group.status === STATUS.PendingOnCustomer || group.status === STATUS.PendingOnVendor"
                                    style="color: var(--background-primary-color);">
                                    Current Open
                                </span>
                                <span *ngIf="group.status === STATUS.AcceptedByCustomer" class="text-success">
                                    Accepted
                                </span>
                                <span *ngIf="group.status === STATUS.RejectedByCustomer" class="text-danger">
                                    Rejected
                                </span>
                                <span>Bid -&nbsp;</span>
                                <span style="color: var(--background-primary-color);">{{ group.vendorName }}</span>
                            </h2>

                        </div>
                        <ng-container *ngIf="jobDetails?.[0]?.counterNumber !== null && jobDetails?.[0]?.counterNumber < 3">
                            <div class="col-4 d-flex justify-content-end" *ngIf="hasCustomerStatus(group)">
                            <button class="btn btn-primary" style="height: 30px;" (click)="toggleCounterMode(group)">
                                {{ group.showCounter ? 'Cancel' : 'Create Counter Proposal' }}
                            </button>
                        </div>
                        </ng-container>
                    </div>

                    <div class="table-responsive-scroll">
                        <table class="table mt-2 counter-table">
                            <thead>
                                <tr>
                                    <!-- <th rowspan="3">Proposal</th> -->
                                    <th class="sticky-col" rowspan="3">Role</th>
                                    <th colspan="2" class="text-center">Customer</th>
                                    <th colspan="2" class="text-center" *ngIf="hasVendorData(group)">Vendor</th>
                                    <th colspan="2" class="text-center" *ngIf="group.showCounter">Proposal</th>
                                </tr>
                                <tr>
                                    <th>Head Count</th>
                                    <th>Basic Wage</th>
                                    <th *ngIf="hasVendorData(group)">Head Count</th>
                                    <th *ngIf="hasVendorData(group)">Basic Wage</th>
                                    <th *ngIf="group.showCounter">Head Count</th>
                                    <th *ngIf="group.showCounter">Basic Wage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of group.items; let i = index">
                                    <!-- <td>{{item.}}</td> -->
                                    <td class="sticky-col">{{ item.skill }}</td>
                                    <td class="customer-column">{{ item.headCount }}</td>
                                    <td class="customer-column">{{ item.maxSalary }}</td>
                                    <td class="vendor-column" *ngIf="hasVendorData(group)">{{ item.vendorCount }}</td>
                                    <td class="vendor-column" *ngIf="hasVendorData(group)">{{ item.vendorPrice }}</td>
                                    <td *ngIf="group.showCounter">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="group.counterInputs[i].headCount"
                                            [placeholder]="item.headCount"
                                            (keypress)="sharedService.isNumberKey($event)" />
                                    </td>
                                    <td *ngIf="group.showCounter">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="group.counterInputs[i].maxSalary"
                                            [placeholder]="item.maxSalary"
                                            (keypress)="sharedService.isNumberKey($event)" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <ng-container>
                        <div class="btn-block mt-3" *ngIf="rowData?.status != 'Cancel'">
                            <ng-container *ngIf="customerAccRejectBtn(group)">
                                <button class="btn btn-primary mr-2"
                                    (click)="orderUpdate(group, 'ACCEPT')">Accept</button>
                                <button class="btn btn-primary reject mr-2"
                                    (click)="orderUpdate(group, 'REJECT')">Reject</button>
                            </ng-container>
                            <span *ngIf="group.showCounter" class="text-right">
                                <button class="btn btn-success" (click)="submitCounter(group)">
                                    Submit Counter
                                </button>
                            </span>
                        </div>
                    </ng-container>

                    
                </div>
            </ng-container>
            <div class="card p-3 mb-2" style="display:none">
                <div class="table-responsive-scroll" *ngIf="rowData?.status == 'Created'">
                    <div class="mt-2 mb-2">
                                <h2>
                                    <span>Current Bid &nbsp;</span>
                                    <!-- <span style="color: var(--background-primary-color);">{{ group.vendorName }}</span> -->
                                </h2>

                            </div>
                            <table class="table mt-2 counter-table">
                                <thead>
                                    <tr>
                                        <!-- <th rowspan="3">Proposal</th> -->
                                        <th class="sticky-col" rowspan="3">Role</th>
                                        <th colspan="2" class="text-center">Customer</th>
                                    </tr>
                                    <tr>
                                        <th>Head Count</th>
                                        <th>Basic Wage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of rowData?.jobLineItems; let i = index">
                                        <!-- <td>{{item.}}</td> -->
                                        <td class="sticky-col">{{ item.skill }}</td>
                                        <td class="customer-column">{{ item.headCount }}</td>
                                        <td class="customer-column">{{ item.maxSalary }}</td>
                                    </tr>
                                </tbody>
                            </table>
                </div>
             </div> 
        </ng-container>

        <!-- Pending Card Table (PendingOnVendor) -->
        <ng-container *ngIf="userType==='VENDOR'">
            <ng-container *ngFor="let group of pendingLineItems; let gIndex = index">
                <div class="card p-3 mb-2">
                    <div class="row">
                        <div class="col">
                            <h2>
                                <span
                                    *ngIf="rowData.status === STATUS.PendingOnCustomer || rowData.status === STATUS.PendingOnVendor"
                                    class="text-primary">
                                    Current Open
                                </span>
                                <span *ngIf="rowData.status === STATUS.AcceptedByCustomer" class="text-success">
                                    Accepted
                                </span>
                                <span *ngIf="rowData.status === STATUS.RejectedByCustomer" class="text-danger">
                                    Rejected
                                </span>
                                <span>Bid</span>
                                <!-- <span style="color: var(--background-primary-color);">{{ rowData?.accountName }}</span> -->
                            </h2>
                        </div>
                        <ng-container *ngIf="rowData?.counterNumber !== null && rowData?.counterNumber < 3 ">
                            <div class="col-4 d-flex justify-content-end" *ngIf="hasVendorStatus()">
                                <button *ngIf=" rowData?.status != 'PendingOnCustomer' &&  rowData?.status != 'PendingOnCustomer' &&  rowData?.status != 'Closed'" class="btn btn-primary"
                                    style="height: 30px;" (click)="toggleCounterMode(group)">
                                    {{ group.showCounter ? 'Cancel' : 'Create Counter Proposal' }}
                                </button>
                            </div>
                        </ng-container>
                    </div>

                    <div class="table-responsive-scroll">
                        <table class="table mt-2 counter-table">
                            <thead>
                                <tr>
                                    <th class="sticky-col" rowspan="3">Vendor Name</th>
                                    <th class="sticky-col" rowspan="3">Role</th>
                                    <th colspan="2" class="text-center">Customer</th>
                                    <th colspan="2" class="text-center" *ngIf="hasVendorData(group)">Vendor</th>
                                    <th colspan="2" class="text-center" *ngIf="group.showCounter">Proposal</th>
                                </tr>
                                <tr>
                                    <th>Head Count</th>
                                    <th>Basic Wage</th>
                                    <th *ngIf="hasVendorData(group)">Head Count</th>
                                    <th *ngIf="hasVendorData(group)">Basic Wage</th>
                                    <th *ngIf="group.showCounter">Head Count</th>
                                    <th *ngIf="group.showCounter">Basic Wage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of group.items; let i = index">
                                    <td style="width:90px" [attr.rowspan]="group.length">
                                        <a class="linklick"
                                            (click)="transactionPraposal(group)">{{group.vendorName}}</a>
                                    </td>
                                    <td class="sticky-col">{{ item.skill }}</td>
                                    <td class="customer-column">{{ item.headCount }}</td>
                                    <td class="customer-column">{{ item.maxSalary }}</td>
                                    <td class="vendor-column" *ngIf="hasVendorData(group)">{{ item.vendorCount }}</td>
                                    <td class="vendor-column" *ngIf="hasVendorData(group)">{{ item.vendorPrice }}</td>
                                    <td *ngIf="group.showCounter">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="group.counterInputs[i].headCount"
                                            [placeholder]="item.headCount"
                                            (keypress)="sharedService.isNumberKey($event)" />
                                    </td>
                                    <td *ngIf="group.showCounter">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="group.counterInputs[i].maxSalary"
                                            [placeholder]="item.maxSalary"
                                            (keypress)="sharedService.isNumberKey($event)" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <ng-container *ngIf="rowData?.status != 'PendingOnCustomer' && rowData?.status != 'Closed'">
                        <div class="btn-block mt-3">
                            <ng-container *ngIf="hasVendorStatus()">
                                <button class="btn btn-primary mr-2"
                                    (click)="orderUpdate(group, 'ACCEPT')">Accept</button>
                                <button class="btn btn-primary reject mr-2"
                                    (click)="orderUpdate(group, 'REJECT')">Reject</button>
                            </ng-container>
                            <span *ngIf="group.showCounter" class="text-right">
                                <button class="btn btn-success" (click)="submitCounter(group)">
                                    Submit Counter
                                </button>
                            </span>
                            <span>
                                <button class="btn btn-primary mr-2"
                                    *ngIf="rowData?.status === STATUS.AcceptedByCustomer" (click)="pushToAssociate()">
                                    Push To Associate
                                </button>
                            </span>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
        <!-- FOR ASSOCIATE -->
        <ng-container *ngIf="userType==='ASSOCIATE'">
            <ng-container >
                <div class="card p-3 mb-2">
                    <div class="row">
                        <div class="col">
                            <!-- <h2>
                                <span
                                    *ngIf="rowData.status === STATUS.PendingOnCustomer || rowData.status === STATUS.PendingOnVendor"
                                    class="text-primary">
                                    Current Open
                                </span>
                                <span *ngIf="rowData.status === STATUS.AcceptedByCustomer" class="text-success">
                                    Accepted
                                </span>
                                <span *ngIf="rowData.status === STATUS.RejectedByCustomer" class="text-danger">
                                    Rejected
                                </span>
                                <span>Bid -&nbsp;</span>
                                <span style="color: var(--background-primary-color);">{{ rowData?.accountName }}</span>
                            </h2> -->
                        </div>
                        <!-- <div class="col-4 d-flex justify-content-end" *ngIf="hasVendorStatus()">
                            <button class="btn btn-primary" style="height: 30px;" (click)="toggleCounterMode(group)">
                                {{ group.showCounter ? 'Cancel' : 'Create Counter Proposal' }}
                            </button>
                        </div> -->
                    </div>

                    <div class="table-responsive-scroll">
                        <table class="table mt-2 counter-table">
                            <thead>
                                <tr>
                                    <th>Role</th>
                                    <th>Basic Wage</th>
                                    <th >Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of jobAssociateMapping; let i = index">
                                    <td class="sticky-col">{{ item.skill }}</td>
                                    <td class="vendor-column">{{ item.price }}</td>
                                    <td *ngIf="item.status == 'AcceptedByUser'">
                                        Accepted
                                        <span [ngClass]=" { 'successPill': item.status == 'AcceptedByUser',
                                            }">Accepted</span>
                                    </td>
                                    <td *ngIf="item?.associateAcceptance == false">
                                    <span [ngClass]=" { 'errorPill': !item?.associateAcceptance,
                                    }">Rejected</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- {{jobAssociateMapping|json}} -->
                    <ng-container *ngFor="let status of jobAssociateMapping; let i = index">
                        <div class="btn-block mt-3" *ngIf="status?.associateAcceptance === undefined || status?.associateAcceptance === null">
                            <button class="btn btn-primary mr-2" (click)="orderUpdateAssociate(jobAssociateMapping, 'ACCEPT')">Accept</button>
                            <button class="btn btn-primary reject mr-2"
                                (click)="orderUpdateAssociate(jobAssociateMapping, 'REJECT')">Reject</button>
                        </div>
                    </ng-container>

                    <!-- <ng-container>
                        <div class="btn-block mt-3">
                            <ng-container *ngIf="hasVendorStatus()">
                                <button class="btn btn-primary mr-2"
                                    (click)="orderUpdate(group, 'ACCEPT')">Accept</button>
                                <button class="btn btn-primary reject mr-2"
                                    (click)="orderUpdate(group, 'REJECT')">Reject</button>
                            </ng-container>
                            <span *ngIf="group.showCounter" class="text-right">
                                <button class="btn btn-success" (click)="submitCounter(group)">
                                    Submit Counter
                                </button>
                            </span>
                            <span>
                                <button class="btn btn-primary mr-2" *ngIf="rowData?.status === STATUS.AcceptedByCustomer" (click)="pushToAssociate()">
                                    Push To Associate
                                </button>
                            </span>
                        </div>
                    </ng-container> -->
                </div>
            </ng-container>
        </ng-container>

     
     

        <!-- <div class="btn-block mt-3">
            <button class="btn btn-primary mr-2" (click)="orderUpdate(groupedLineItems, 'ACCEPT')">Accept</button>
            <button class="btn btn-primary reject mr-2"
                (click)="orderUpdate(groupedLineItems, 'REJECT')">Reject</button>
        </div> -->


     
    </div>

    <div class="btn-wrapper mt-2" >
        <button class="btn btn-primary mr-2"  (click)="editEvent()" *ngIf="userType==='CUSTOMER' && rowData.status === 'Created'">Edit</button>
        <button class="btn btn-primary mr-2" (click)="pushToVendor()" *ngIf="userType==='CUSTOMER' && rowData.status === 'Created'">Push To Vendor</button>
        <ng-container *ngIf="userType === 'CUSTOMER'">
            <button  *ngIf="showCancelBtn" class="btn btn-danger" (click)="cancelOrder()" >Cancel Order</button>
        </ng-container>
    </div>
</div>





<p-dialog header="Creater Counter Proposal" [modal]="true" [(visible)]="createCounterPopup" (onHide)="onCounterPopupClose()"
    [style]="{ width: '65rem' }">
    <!-- {{createCounterData|json}}<br /> -->
   
    <div class="container mt-4">
        <h2>Vendor: {{ createCounterData?.vendorName }}</h2>

        <table class="table table-bordered table-striped mt-3">
            <thead class="table-light">
            <tr>
                <th>Skill</th>
                <th>Vendor Count</th>
                <th>Vendor Price</th>
                <th>Head Count</th>
                <th>Max Salary</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of createCounterData?.items; let i = index">
                <td>{{ item.skill }}</td>
                <td>{{ item.vendorCount }}</td>
                <td>{{ item.vendorPrice }}</td>
                <td>
                <input type="number"
                        class="form-control text-center"
                        [(ngModel)]="item.headCount"
                        (ngModelChange)="updateCounterInputs(i)">
                </td>
                <td>
                <input type="number"
                        class="form-control text-center"
                        [(ngModel)]="item.maxSalary"
                        (ngModelChange)="updateCounterInputs(i)">
                </td>
            </tr>
            </tbody>
        </table>

        <!-- <button class="btn btn-primary mt-3" (click)="saveCounterCustomer()">Update JSON</button> -->

        <!-- <h4 class="mt-4">Updated JSON Output:</h4> -->
        <!-- <pre>{{ createCounterData | json }}</pre> -->
        </div>


    <div class="flex justify-end gap-2 mt-4">
        <a class="btn btn-primary" (click)="submitCounterCustomer(createCounterData)">Create Counter</a>
        <!-- <a class="btn btn-primary btn-denger" (click)="approveClick('reject')">Reject</a> -->
    </div>
</p-dialog>



<p-dialog header="Order Bidding History" [modal]="true" [(visible)]="BiddingHistoryPopup" [style]="{ width: '60rem' }">
    <!-- Cancel Card Table -->
    <ng-container *ngIf="transactionData?.length > 0">
        <div class="carda p-0 mt-4">
            <!-- <div class="row">
                    <div class="col">
                        <h2>Order Bidding History</h2>
                    </div>
                </div> -->

            <div class="table-responsive-scroll">
                <table class="table mt-0 counter-table">
                    <thead>
                        <tr>
                            <th rowspan="3">Counter </th>
                            <th rowspan="3">Skill </th>
                            <!-- <th rowspan="3">Route</th> -->
                            <ng-container *ngIf="userType === 'VENDOR'">
                                <th colspan="2" class="text-center">Customer</th>
                                <th colspan="2" class="text-center">Vendor</th>
                            </ng-container>
                            <ng-container *ngIf="userType === 'CUSTOMER'">
                                <th colspan="2" class="text-center">Vendor</th>
                                <th colspan="2" class="text-center">Customer</th>
                            </ng-container>
                        </tr>
                        <tr>
                            <th>Head Count</th>
                            <th>Basic Wage</th>
                            <th>Head Count</th>
                            <th>Basic Wage</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let group of transactionDataTransform">
                            <ng-container *ngFor="let row of group.rows; let i = index">
                                <tr>
                                    <!-- show counter only for the first row with rowspan -->
                                    <td *ngIf="i === 0" [attr.rowspan]="group.rows.length">Counter {{ group.counter }}
                                    </td>
                                    <td>{{row?.skill}}</td>
                                    <ng-container *ngIf="userType === 'VENDOR'">
                                        <td>{{ row.headCount }}</td>
                                        <td>{{ row.maxSalary }}</td>
                                        <td>{{ row.vendorCount }}</td>
                                        <td>{{ row.vendorPrice }}</td>
                                    </ng-container>
                                    <ng-container *ngIf="userType === 'CUSTOMER'">
                                        <td>{{ row.vendorCount }}</td>
                                        <td>{{ row.vendorPrice }}</td>
                                        <td>{{ row.headCount }}</td>
                                        <td>{{ row.maxSalary }}</td>
                                    </ng-container>

                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="transactionData && transactionData?.length == 0">
        <p style="color: red;margin: 30px 0 0;">No Order Bidding History</p>
    </ng-container>

</p-dialog>


